<kendo-window #mainWindow *ngIf="_active"
    title="{{ _pageState == 2 ? 'ADD NEW RECORD' : _pageState == 3 ? 'EDIT RECORD' : _pageState == 1 ? 'VIEW RECORD' : _pageState == 4 ? 'EDIT FIELDS MODE' : 'Reservation' }}"
    (close)="_closeForm()" (stateChange)="_onStateChanges($event)" class="fullWidthFormForm"
    [class.editFieldsModeClass]="_pageState == 4" (keydown.enter)="$event.preventDefault()">
    <form novalidate [formGroup]="_form" (keydown.enter)="$event.preventDefault()" class="form_style">
        <div class="row">
            <div class="col-12">
                <div class="reservation-section-header">
                    <div class="reservation-section-header-title">
                        <span>Reservation</span>
                    </div>
                    <div class="header-actions">

                        <ul class="menuButtonsList">
                            <!-- <li *ngIf="canAccess(_permissionScope, 'update') && _currentUser.appRole.id!=3 && _currentUser.appRole.id!=4"
                  (click)="_onEditForms()"
                  [class.ViewModelHiddenElement]="_pageState != 2">
                Edit Forms
              </li> -->
                            <li *ngIf="_hasFieldControlLicense && _currentUser.appRole.id!=3 && _currentUser.appRole.id!=4" class="wikiButton"
                                (click)="_onEditFields()" [class.ViewModeHiddenElement]="_pageState != 2">
                                Edit Fields
                            </li>
                            <li *ngIf="_hasFieldControlLicense" class="wikiButton" (click)="_returnAdNew()"
                                [class.ViewModeHiddenElement]="_pageState != 4">
                                Close Edit Fields
                            </li>
                            <!-- <li class="wikiButton">Wiki</li> [class.disabled]="_deactivatedFieldsGridData?.length == 0"-->
                            <!-- <li *ngIf="_pageState == 2"
                  class="wikiButton"
                  (click)="_viewInactiveFields()">
                View Inactive Fields
              </li> -->
                        </ul>

                        <!-----Close--->
                        <button class="steps_buttons_class" kendoButton (click)="_onCancel()"
                            [disabled]="_pageState == pageState?.EDIT_FIELDS ? true : false  ">
                            <span>
                                <img [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                            </span>Close
                        </button>
                        <!-----Print--->
                        <!-- <button class="steps_buttons_class"
                    kendoButton
                    *ngIf="_pageState != pageState?.VIEW && (_pageState ==  pageState?.ADD || _pageState ==  pageState?.EDIT_FIELDS)"
                    (click)="_onSave('saveAndPrint')"
                    [disabled]="_pageState == pageState?.EDIT_FIELDS ? true : false ">

              <span>
                <img [src]="'/assets/menu/'+ _theme +'/print-icon.svg'" />
              </span><span style="color: unset;">
                Save & Print
              </span>
            </button> -->
                        <!-----saveAndCopy--->
                        <button kendoButton class="steps_buttons_class" *ngIf="((_pageState == pageState?.EDIT) ||
                    (_pageState != pageState?.VIEW))
                    && canAccess('asset-reservation', 'create')"
                            [disabled]="_pageState == pageState?.EDIT_FIELDS ? true : false"
                            (click)="_onSave('saveAndCopy')">
                            <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                            <span>save & Copy</span>
                        </button>

                        <!-----saveAndNew----->
                        <button kendoButton class="steps_buttons_class" *ngIf="canAccess('asset-reservation', 'create')"
                            (click)="_onSave('saveAndNew')">
                            <img class="backimage" [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                            <span>save & New</span>
                        </button>

                        <!-----saveAndClose----->
                        <button class="steps_buttons_class" kendoButton (click)="_onSave('saveAndClose')"
                            *ngIf="canAccess('asset-reservation', 'create')">
                            <span>
                                <img [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" />
                            </span> Save & Close
                        </button>
                        <!-----save----->
                        <button class="steps_buttons_class" kendoButton (click)="_onSave('save')"
                            *ngIf="canAccess('asset-reservation', 'create')">
                            <span><img [src]="'/assets/menu/'+ _theme +'/save-icon-group.svg'" /></span>Save
                        </button>

                    </div>

                </div>
            </div>
        </div>

        <!-- Mouhab -->

        <div class="row no-row-margin">
            <!-- Left Panel -->
            <div class="col-12 col-lg-6 small-pad-right">
                <div
                    [ngClass]="isGeneralInformationExpanded == true ? 'transactionWidget' : 'transactionWidget-collapse'">
                    <div class="row">
                        <div class="col-12 sectionheader special_style_formgroup">
                            <span class="titleStandardStyle">General Information</span>
                            <span
                                [ngClass]="isGeneralInformationExpanded == true ? 'k-icon k-i-sort-asc-sm' :  'k-icon k-i-sort-desc-sm'"
                                class="float-right pointer-click"
                                (click)="ExpandCollapseGeneralInfoWidget(isGeneralInformationExpanded)"></span>
                        </div>
                        <ng-container *ngIf="isGeneralInformationExpanded">
                            <!-- LBL_AssetReservationMadeDate -->
                            <div class="col-12 margin-top-2"
                                *ngIf="getAuthByLabel('LBL_AssetReservationMadeDate')?.canView || _pageState == 4">
                                <div class="form-group special_style_formgroup">
                                    <div class="row">
                                        <div class="col-2">
                                            <label
                                                class="control-label">{{getLabel("LBL_AssetReservationMadeDate")?.currentText}}</label>
                                        </div>
                                        <div class="col-10 transaction-move-input-fields">
                                            <kendo-datetimepicker class="k-datepicker datepickerControlrightMargin"
                                                [attr.required]="getLabel('LBL_AssetReservationMadeDate')?.isRequired ? 'required' : null"
                                                [ngClass]="{'bordered': $safeNavigationMigration(getLabel('LBL_AssetReservationMadeDate')?.isRequired), 'disabled': getAuthByLabel('LBL_AssetReservationMadeDate')?.canEdit ? false : true}"
                                                formControlName="reservationMadeDate" [disabled]="!_dateEnabled"
                                                [min]="_minDateToday" placeholder="Set Date and Time"
                                                [format]="_datePickerFormat">
                                            </kendo-datetimepicker>
                                            <a [class.editfieldsIconvisible]="_pageState == 4" class="editFieldsIcon"
                                                (click)="_openRenameForm('LBL_AssetReservationMadeDate', true)">
                                                <img class="searchIcon"
                                                    [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'"
                                                    style="margin-left: 25px !important;" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- LBL_AssetReservationNumber -->
                            <div class="col-12 margin-top-2">
                                <div *ngIf="getAuthByLabel('LBL_AssetReservationNumber')?.canView"
                                    class="special_style_formgroup">
                                    <div class="row">
                                        <div class="col-2">
                                            <label for="reservationNumber"
                                                class="pad-right-0 control-label">{{getLabel("LBL_AssetReservationNumber")?.currentText}}</label>
                                        </div>
                                        <div class="col-10 transaction-move-input-fields">
                                            <input #po_input type="text" class="k-textbox writebox min-width-0"
                                                [placeholder]="'Reservation#'"
                                                (keyup.enter)="reservationNumberChanged()"
                                                (keydown.Tab)="reservationNumberChanged()"
                                                (blur)="reservationNumberChanged()" formControlName="reservationNumber"
                                                required />
                                            <a *ngIf="_pageState != 4" class="cursor-pointer"
                                                (click)="_generateBarcodeClick()">
                                                <img class="searchIcon"
                                                    [src]="'/assets/menu/'+ _theme +'/auto-generate-icon.svg'" />
                                            </a>
                                            <a [class.editfieldsIconvisible]="_pageState == 4" class="editFieldsIcon"
                                                (click)="_openRenameForm('LBL_AssetReservationNumber', true)">
                                                <img class="searchIcon"
                                                    [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <!-- LBL_AssetToBeCheckedOutDate -->
                            <div class="col-12 margin-top-2"
                                *ngIf="getAuthByLabel('LBL_AssetToBeCheckedOutDate')?.canView || _pageState == 4">
                                <div class="form-group special_style_formgroup">
                                    <div class="row">
                                        <div class="col-2">
                                            <label
                                                class="control-label">{{getLabel("LBL_AssetToBeCheckedOutDate")?.currentText}}</label>
                                        </div>
                                        <div class="col-10 transaction-move-input-fields">

                                            <kendo-datetimepicker class="k-datepicker datepickerControlrightMargin"
                                                [attr.required]="getLabel('LBL_AssetToBeCheckedOutDate')?.isRequired ? 'required' : null"
                                                [ngClass]="{'bordered': $safeNavigationMigration(getLabel('LBL_AssetToBeCheckedOutDate')?.isRequired), 'disabled': getAuthByLabel('LBL_AssetToBeCheckedOutDate')?.canEdit ? false : true}"
                                                formControlName="toBeCheckedOutDate" [min]="_minDateToday"
                                                placeholder="Set Date and Time" [format]="_datePickerFormat">
                                            </kendo-datetimepicker>
                                            <a [class.editfieldsIconvisible]="_pageState == 4" class="editFieldsIcon"
                                                (click)="_openRenameForm('LBL_AssetToBeCheckedOutDate', true)">
                                                <img class="searchIcon"
                                                    [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'"
                                                    style="margin-left: 25px !important;" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- LBL_AssetToBeCheckedInDate -->
                            <div class="col-12 margin-top-2"
                                *ngIf="getAuthByLabel('LBL_AssetToBeCheckedInDate')?.canView || _pageState == 4">
                                <div class="form-group special_style_formgroup">
                                    <div class="row">
                                        <div class="col-2">
                                            <label
                                                class="control-label">{{getLabel("LBL_AssetToBeCheckedInDate")?.currentText}}</label>
                                        </div>
                                        <div class="col-10 transaction-move-input-fields">

                                            <kendo-datetimepicker class="k-datepicker datepickerControlrightMargin"
                                                [attr.required]="getLabel('LBL_AssetToBeCheckedInDate')?.isRequired ? 'required' : null"
                                                [ngClass]="{'bordered': $safeNavigationMigration(getLabel('LBL_AssetToBeCheckedInDate')?.isRequired), 'disabled': getAuthByLabel('LBL_AssetToBeCheckedInDate')?.canEdit ? false : true}"
                                                formControlName="toBeCheckedInDate" [min]="_minDateToday"
                                                placeholder="Set Date and Time" [format]="_datePickerFormat">
                                            </kendo-datetimepicker>
                                            <a [class.editfieldsIconvisible]="_pageState == 4" class="editFieldsIcon"
                                                (click)="_openRenameForm('LBL_AssetToBeCheckedInDate', true)">
                                                <img class="searchIcon"
                                                    [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'"
                                                    style="margin-left: 25px !important;" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- LBL_AssetReservationLocation -->
                            <div class="col-12 margin-top-2"
                                *ngIf="(getAuthByLabel('LBL_AssetReservationLocation')?.canView && _locationVisible) || _pageState == 4">
                                <div class="form-group special_style_formgroup">
                                    <div class="row">
                                        <div class="col-2">
                                            <label for="location" class="control-label">
                                                {{getLabel("LBL_AssetReservationLocation")?.currentText}}
                                            </label>
                                        </div>
                                        <!-- [ngClass]="{'bordered': getLabel('LBL_AssetReservationLocation')?.isRequired, 'disabled': getAuthByLabel('LBL_AssetReservationLocation')?.canEdit ? false : true}" -->
                                        <div class="col-10 transaction-move-input-fields">
                                            <kendo-combobox #Kendo_Combobox_Location [data]="locationsData"
                                                [suggest]="true" [placeholder]="'Select a Location'"
                                                formControlName="checkOutToLocation" [textField]="'code'"
                                                [valueField]="'id'" id="checkOutToLocation" name="checkOutToLocation"
                                                (valueChange)="_handleLocationChange($event)"
                                                [attr.disabled]="(getAuthByLabel('LBL_AssetReservationLocation')?.canEdit && _pageState != 4 ) ? null : 'disabled'"
                                                [attr.required]="getLabel('LBL_AssetReservationLocation')?.isRequired ? 'required' : null"
                                                class="bordered">
                                            </kendo-combobox>
                                            <!-- Add New Link -->
                                            <a *ngIf="getAuthByLabel('LBL_AssetReservationLocation')?.canEdit && _locationsAuth?.canAdd && _locationEnabled "
                                                [class.ViewModeHiddenElement]="_pageState == 1 || _pageState == 4"
                                                class="cursor-pointer" (click)=" _openForm(_locationsPageName)">
                                                <img class="searchIcon"
                                                    [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'" />
                                            </a>
                                            <!-- Fetch / Select-->
                                            <span
                                                *ngIf="getAuthByLabel('LBL_AssetReservationLocation')?.canEdit && _locationEnabled "
                                                [class.ViewModeHiddenElement]="_pageState == 1 || _pageState == 4"
                                                class="asap-input-icon">
                                                <img class="addIcon" (click)="_openLocationsList()"
                                                    [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'" />
                                            </span>

                                            <a [class.editfieldsIconvisible]="_pageState == 4" class="editFieldsIcon"
                                                (click)="_openRenameForm('LBL_AssetReservationLocation', true)">
                                                <img class="searchIcon"
                                                    [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                            </a>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- LBL_AssetReservationPerson -->
                            <div class="col-12 margin-top-2"
                                *ngIf="(getAuthByLabel('LBL_AssetReservationPerson')?.canView && _personVisible) || _pageState == 4">
                                <div class="form-group special_style_formgroup">
                                    <div class="row">
                                        <div class="col-2">
                                            <label for="toPerson" class="control-label">
                                                {{getLabel("LBL_AssetReservationPerson")?.currentText}}
                                            </label>
                                        </div>
                                        <div class="col-10 transaction-move-input-fields">
                                            <kendo-combobox #Kendo_Combobox_Persons class="bordered newFormControlWidth"
                                                [data]="personsData" [suggest]="true" [placeholder]="'Select a Person'"
                                                id="checkOutToPerson" name="checkOutToPerson"
                                                formControlName="checkOutToPerson" [textField]="'code'"
                                                [valueField]="'id'" (valueChange)="_handlePersonChange($event)"
                                                [attr.disabled]="(getAuthByLabel('LBL_AssetReservationPerson')?.canEdit && _pageState != 4 ) ? null : 'disabled'"
                                                [attr.required]="getLabel('LBL_AssetReservationPerson')?.isRequired ? 'required' : null">
                                            </kendo-combobox>
                                            <!-- Add New Link -->
                                            <a *ngIf="getAuthByLabel('LBL_AssetReservationPerson')?.canEdit && _personsAuth?.canAdd && _personEnabled"
                                                [class.ViewModeHiddenElement]="_pageState == 1 || _pageState == 4"
                                                class="cursor-pointer" (click)="_openForm('persons')">
                                                <img class="searchIcon"
                                                    [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'" />
                                            </a>
                                            <!-- Fetch / Select-->
                                            <span
                                                *ngIf="getAuthByLabel('LBL_AssetReservationPerson')?.canEdit && _personEnabled "
                                                [class.ViewModeHiddenElement]="_pageState == 1 || _pageState == 4"
                                                class="asap-input-icon">
                                                <img class="addIcon" (click)="_openPersonsList()"
                                                    [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'" />
                                            </span>
                                            <a [class.editfieldsIconvisible]="_pageState == 4" class="editFieldsIcon"
                                                (click)="_openRenameForm('LBL_AssetReservationPerson', true)">
                                                <img class="searchIcon"
                                                    [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                            </a>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Documents Uploader -->
                            <div class="col-12 margin-top-2 d-none">
                                <div class="form-group special_style_formgroup">
                                    <div class="row">
                                        <div class="col-2">
                                            <label class="control-label">
                                                Attach Document
                                            </label>
                                        </div>
                                        <div #kendo_uploader_wrapper class="col-10 transaction-move-input-fields"
                                            style="display:flex;">
                                            <kendo-upload #kendo_uploader [class.active]="true"
                                                [class.disabled]="_pageState == 4" [batch]="false" [autoUpload]="false"
                                                [multiple]="true" class="NextToLabelUpload requiredDropZone"
                                                (select)="_fileSelectedChanges($event)"
                                                (remove)="_fileRemoveEventHandler($event)" formControlName="stream">
                                                <kendo-upload-messages [select]="_uploaderSelectMessage"
                                                    [dropFilesHere]="''">
                                                </kendo-upload-messages>
                                            </kendo-upload>
                                            <a class="cursor-pointer" (click)="_onUploadClick()"
                                                [class.ViewModeHiddenElement]="_pageState == 1 || _pageState == 4">
                                                <img class="searchIcon"
                                                    [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'" />
                                            </a>
                                            <a (click)="_showDocumentsGrid=true" class="asap-input-icon"
                                                [class.ViewModeHiddenElement]="_pageState == 1 || _pageState == 4">
                                                <img _ngcontent-sqy-c791="" class="addIcon"
                                                    [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'">
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <!-- Right Panel -->
            <div class="col-12 col-lg-6 small-pad-left">
                <div [ngClass]="isScanAssetExpanded == true ? 'transactionWidget' : 'transactionWidget-collapse'">
                    <div class="row">
                        <div class="col-12 sectionheader special_style_formgroup">
                            <span class="titleStandardStyle">Scan Asset#</span>
                            <span
                                [ngClass]="isScanAssetExpanded == true ? 'k-icon k-i-sort-asc-sm' : 'k-icon k-i-sort-desc-sm'"
                                class="float-right pointer-click"
                                (click)="ExpandCollapseScanAssetWidget(isScanAssetExpanded)">
                            </span>
                        </div>
                        <ng-container *ngIf="isScanAssetExpanded">

                            <!-- LBL_AssetReservationAssetNumber -->
                            <div class="col-12 margin-top-2"
                                *ngIf="getAuthByLabel('LBL_AssetReservationAssetNumber')?.canView || _pageState == 4">
                                <div class="form-group special_style_formgroup">
                                    <div class="row">
                                        <div class="col-2">
                                            <label for="notes" class="control-label">
                                                {{getLabel("LBL_AssetReservationAssetNumber")?.currentText}}
                                            </label>
                                        </div>
                                        <div [ngClass]="_printReceiptSettings && _printReceiptSettings.enabled ? 'col-8 transaction-move-input-fields' : 'col-10 transaction-move-input-fields'">
                                            <kendo-combobox appDebounceFilter #Kendo_Combobox_Assets
                                                class="bordered newFormControlWidth" [data]="assetsDataFiltered"
                                                [suggest]="true" [filterable]="true" [placeholder]="'Select an Asset'"
                                                id="assetNumber" name="assetNumber" formControlName="assetNumber"
                                                [textField]="'assetNumber'" [valueField]="'id'"
                                                (selectionChange)="_handleAssetChange()"
                                                (keyup.enter)="_handleAssetKeyEnter()"
                                                (filterChange)="_handleAssetsFilter($event)"
                                                (opened)="scrollCombobox($event)" [virtual]="virtual"
                                                [attr.disabled]="(getAuthByLabel('LBL_AssetReservationAssetNumber')?.canEdit && _pageState != 4) ? null : 'disabled'"
                                                [attr.required]="getLabel('LBL_AssetReservationAssetNumber')?.isRequired ? 'required' : null"
                                                [disabled]="(getAuthByLabel('LBL_AssetReservationAssetNumber')?.canEdit && _pageState != 4) ? false : true">
                                                <!-- Not Existing Template -->
                                                <ng-template kendoComboBoxNoDataTemplate>
                                                    <div class="stocksettEnabledContainer">
                                                        <span class="missing-item-txt">
                                                            No data found.<br />
                                                        </span>
                                                    </div>
                                                </ng-template>
                                                <!-- Item Template -->
                                                <ng-template kendoComboBoxItemTemplate let-dataItem>
                                                    <div class="transactions-receive-stock-dropdown-item">
                                                        <div class="truncate">
                                                            {{ dataItem.assetNumber }}
                                                            <span *ngIf="dataItem.assetName"> | {{ dataItem.assetName
                                                                }}</span>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </kendo-combobox>
                                            <span *ngIf="getAuthByLabel('LBL_AssetReservationAssetNumber')?.canEdit"
                                                [class.ViewModeHiddenElement]="_pageState == 1 || _pageState == 4"
                                                class="asap-input-icon">
                                                <img class="addIcon" (click)="_openAssetsList()"
                                                    [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'" />
                                            </span>
                                            <a [class.editfieldsIconvisible]="_pageState == 4" class="editFieldsIcon"
                                                (click)="_openRenameForm('LBL_AssetReservationAssetNumber', true)">
                                                <img class="searchIcon"
                                                    [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                            </a>
                                        </div>
                                        <div *ngIf="_printReceiptSettings && _printReceiptSettings.enabled" class="col-2 transactions-checkout-stock-right-checkbox">
                                            <input type="checkbox"
                                                   class="k-checkbox"
                                                   id="printReceipt"
                                                   formControlName="printReceipt"
                                                   [attr.disabled]="(_pageState != 4) ? null : 'disabled'"
                                                   kendoCheckBox />
                                            <div class="transactions-checkout-stock-right-checkbox-text">
                                                <label style="cursor: pointer;" for="printReceipt">Print Receipt</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="section-separator"></div>
                            <!-- LBL_AssetReservationNotes -->
                            <div class="col-12 margin-top-2"
                                *ngIf="getAuthByLabel('LBL_AssetReservationNotes')?.canView || _pageState == 4">
                                <div class="form-group special_style_formgroup">
                                    <div class="row">
                                        <div class="col-2">
                                            <label for="notes" class="control-label">
                                                {{getLabel("LBL_AssetReservationNotes")?.currentText}}
                                            </label>
                                        </div>
                                        <div class="col-10 transaction-textarea-fields">
                                            <textarea class="" rows="4" formControlName="notes" id="notes" name="notes"
                                                placeholder="Transaction Notes..."
                                                [attr.disabled]="(getAuthByLabel('LBL_AssetReservationNotes')?.canEdit && _pageState != 4) ? null : 'disabled'"
                                                [attr.required]="getLabel('LBL_AssetReservationNotes')?.isRequired ? 'required' : null"
                                                [disabled]="(getAuthByLabel('LBL_AssetReservationNotes')?.canEdit && _pageState != 4) ? false : true"
                                                [ngClass]="{'bordered': $safeNavigationMigration(getLabel('LBL_AssetReservationNotes')?.isRequired), 'disabled': getAuthByLabel('LBL_AssetReservationNotes')?.canEdit ? false : true}"></textarea>
                                            <a title="Edit {{getLabel('LBL_AssetReservationNotes')?.currentText}}"
                                                [class.editfieldsIconvisible]="_pageState == 4" class="editFieldsIcon"
                                                (click)="_openRenameForm('LBL_AssetReservationNotes')">
                                                <img class="searchIcon"
                                                    [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <!-- Details -->
            <div class="col-12">
                <div class="transactionWidget with-grid">
                    <div class="flex-space-between transaction-move-grid-header-wrapper">
                        <div class="titleStandardStyle d-flex">
                            <div class="asap-grid-remove_new">
                                Selected Items ({{_selectedItems.length}})
                            </div>
                            <!-- <div *ngIf="_gridSelectedAssets.length > 0">
              <button class="asap-grid-remove" (click)="_onRemoveDetailsBatch()">
                <div class="asap-grid-remove-icon">
                  <img src="/assets/menu/enterprise/remove-icon.svg" />
                </div>
                <div class="asap-grid-remove-text">Delete Selected Items</div>
              </button>
            </div> -->
                        </div>
                        <!-- <div class="transaction-move-grid-top-actions">
            <div class="transaction-move-grid-top-actions-radio">
              <input type="radio"
                     id="new-to-old-items"
                     name="transaction-move-duration"
                     value="new"
                     [formControl]="_sortingSelected"
                     kendoRadioButton />
              <label class="k-radio-label" [for]="'new-to-old-items'">
                Newest To Oldest
              </label>
            </div>
            <div class="transaction-move-grid-top-actions-radio">
              <input type="radio"
                     id="old-to-new-items"
                     name="transaction-move-duration"
                     value="old"
                     [formControl]="_sortingSelected"
                     kendoRadioButton />
              <label class="k-radio-label" [for]="'old-to-new-items'">
                Oldest To Newest
              </label>
            </div>
          </div> -->
                    </div>

                    <kendo-grid [kendoGridBinding]="_selectedItems" [scrollable]="'none'"
                        class="transaction-grid transaction-move-grid ReceiveTransactionDetails" [sortable]="true"
                        [resizable]="true" (remove)="_removeHandler($event)">

                        <kendo-grid-column field="assetNumber" title="Asset #">
                        </kendo-grid-column>

                        <kendo-grid-column field="assetName" title="Asset name">
                        </kendo-grid-column>

                        <kendo-grid-column field="locationCode" title="Location" *ngIf="_locationEnabled">
                        </kendo-grid-column>

                        <kendo-grid-command-column title="Action" tooltip="Action">
                            <!-- *ngIf="_blindType" -->
                            <ng-template kendoGridCellTemplate>
                                <div kendoGridRemoveCommand class="asap-grid-remove">
                                    <div class="asap-grid-remove-icon">
                                        <img src="/assets/menu/enterprise/remove-icon.svg" /> Delete
                                    </div>
                                </div>
                            </ng-template>
                        </kendo-grid-command-column>

                    </kendo-grid>


                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <asap-forms-validation-summary *ngIf="_invalidForm" [additionalErrors]="_additionalErrors"
                    [form]="_form" [page]="_page">
                </asap-forms-validation-summary>
            </div>
            <div class="k-overlay" *ngIf="_editFormActive || _personsListEnabled || _locationsListEnabled || _showDocumentsGrid 
                || _assetsListEnabled || showReports || _isEditForms || _deactivatedFieldsForm">
            </div>
        </div>
        <asap-dialog-layout *ngIf="_isDialiog" [data]="_dialogModel" [componentName]="_dialogComponentName"
            (closeDialog)="_closeDialog($event)">
        </asap-dialog-layout>
        <!-- Mouhab -->





    </form>
    <kendo-window *ngIf="_assetsListEnabled" title="Add Asset to Reservation" (close)="_closeAssetsList()"
        [resizable]="false" [minHeight]="120" class="addFromLibrary">
        <div class="greytabtop">
            <button kendoButton class="topRightButtonSelect" (click)="_returnSelectedAssetsHandler($event)">
                Select & Return
            </button>
        </div>
        <asap-grid-layout [singleSelect]="false" [selectable]="true" [groupingEnabled]="true" [pagingEnabled]="true"
            [headerEnable]="true" [headerTitle]="'Select An Asset'" [entityName]="_entity" [addNewFormEnabled]="false"
            [enableSiteSelection]="false" [orderEnable]="true" [page]="_assetsPageName" [deletedEnabled]="false"
            [selectByField]="'id'" [selectByFieldTitle]="''" [filteringEnable]="true" [sortingEnabled]="true"
            [HideNotesFields]="true" [resolver]="_getAssets"
            (onRowSelectionChanges)="_onAssetsRowSelectionChanges($event)"
            (onRowObjectSelectionChanges)="_onAssetsObjectRowSelectionChanges($event)">
            <ng-container *ngFor="let column of _assetsGridFields">
                <ng-container *ngIf="column.selected">
                    <ng-container *ngIf="!column.isTemplate">
                        <ng-template pageListColumn [field]="column.field"
                            [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                            [type]="column.type" let-item>
                            <ng-container *ngIf="column.type == 'date' && column.isCustomField == false">
                                {{ item[column.field] | dateFormat }}
                            </ng-container>
                            <ng-container *ngIf="column.type != 'date' && column.isCustomField == false">
                                {{column.field | complexFieldValue: item}}
                            </ng-container>
                            <ng-container *ngIf="column.isCustomField == true">
                                {{item[column.field]}}
                            </ng-container>
                        </ng-template>
                    </ng-container>
                    <ng-container *ngIf="column.isTemplate">
                        <ng-template pageListColumn [field]="column.field"
                            [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                            [type]="column.type" let-item>
                            <ng-container
                                *ngIf="column.type == 'date' && column.isCustomField == false && (column.field != 'assetFiles.file.thumbnail' && column.field != 'model.modelFiles.file.thumbnail')">
                                {{ item[column.field] | dateFormat }}
                            </ng-container>
                            <ng-container *ngIf="column.type != 'date' && column.isCustomField == false && (column.field != 'assetFiles.file.thumbnail' && column.field != 'model.modelFiles.file.thumbnail')
            && column.formatType != costPriceFormatType">
                                {{column.field | complexFieldValue: item}}
                            </ng-container>
                            <ng-container *ngIf="column.formatType == costPriceFormatType">
                                {{column.field | complexFieldValue: item | costFormat}}
                            </ng-container>
                            <ng-container *ngIf="column.field == 'assetFiles.file.thumbnail' && column.type == 'image'">
                                <div class="Asset-icon"
                                    *ngIf="item.assetFiles != undefined && item.assetFiles.length > 0">
                                    <img appImagePopup
                                        [src]="displayAssetImage(column.field | complexFieldValue: item,item.assetFiles)"
                                        width="100" />
                                </div>
                            </ng-container>
                            <ng-container
                                *ngIf="column.field == 'model.modelFiles.file.thumbnail' && column.type == 'image'">
                                <div class="Asset-icon"
                                    *ngIf="item.model?.modelFiles != undefined && item.model?.modelFiles?.length > 0">
                                    <img appImagePopup
                                        [src]="displayModelImage(column.field | complexFieldValue: item,$safeNavigationMigration(item.model?.modelFiles))"
                                        width="100" />
                                </div>
                            </ng-container>
                            <ng-container *ngIf="column.isCustomField == true">
                                {{item[column.field]}}
                            </ng-container>
                        </ng-template>
                    </ng-container>
                </ng-container>
            </ng-container>

        </asap-grid-layout>
    </kendo-window>
    <kendo-window *ngIf="_showDocumentsGrid" title="Add Document(s) to Reservation" (close)="_closeDocumentsWindow()"
        [resizable]="false" [minHeight]="120" class="addFromLibrary">
        <div class="greytabtop">
            <button kendoButton class="topRightButtonSelect" (click)="_returnSelectedDocumentsHandler($event)">
                Select & Return
            </button>
        </div>
        <asap-grid-layout [selectable]="true" [pagingEnabled]="true" [selectByField]="'id'" [selectByFieldTitle]="''"
            [enableSiteSelection]="false" [sortingEnabled]="true" [filteringEnable]="true" [orderEnable]="true"
            [HideNotesFields]="true" [selectedKeys]="_selectedDocumentsKeys" [resolver]="_getAccountDocuments"
            (onRowSelectionChanges)="_onDocumentRowSelectionChanges($event)"
            (onRowObjectSelectionChanges)="_onDocumentbjectRowSelectionChanges($event)">
            <ng-template pageListColumn name="Name" field="name" let-item>
                {{item.name}}
            </ng-template>
            <ng-template pageListColumn name="Description" field="description" let-item>
                {{item.description}}
            </ng-template>
            <ng-template pageListColumn name="Type" field="type" let-item>
                {{item.type}}
            </ng-template>
            <ng-template pageListColumn name="Stream" let-item>
                <img src="{{ item.stream }}" alt="{{ item.name }}" width="50" />
            </ng-template>
        </asap-grid-layout>
    </kendo-window>

    <kendo-window *ngIf="_locationsListEnabled" title="" (close)="_closeLocationsList()" class="addFromLibrary">
        <div class="greytabtop">
            <button kendoButton class="topRightButtonSelect" (click)="_returnSelectedLocationsHandler($event)">
                Select & Return
            </button>
        </div>
        <asap-grid-layout [selectable]="true" [singleSelect]="true" [groupingEnabled]="true" [pagingEnabled]="true"
            [headerEnable]="true" [headerTitle]="''" [entityName]="_entity" [addNewFormEnabled]="false"
            [orderEnable]="true" [sortingEnabled]="true" [page]="_locationsPageName" [deletedEnabled]="false"
            [selectByField]="'id'" [selectByFieldTitle]="''" [enableSiteSelection]="false" [filteringEnable]="true"
            [HideNotesFields]="true" [resolver]="_getLocations"
            (onRowSelectionChanges)="_onLocationsRowSelectionChanges($event)"
            (onRowObjectSelectionChanges)="_onLocationsObjectRowSelectionChanges($event)">
            <ng-container *ngFor="let column of _locationsGridFields">
                <ng-container *ngIf="column.selected">
                    <ng-container *ngIf="!column.isTemplate">
                        <ng-template pageListColumn [field]="column.field"
                            [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                            [type]="column.type" let-item>
                            <ng-container
                                *ngIf="column.type == 'date' && column.isCustomField == false && column.field != 'notes'">
                                {{ item[column.field] | dateFormat }}
                            </ng-container>
                            <ng-container
                                *ngIf="column.type != 'date' && column.isCustomField == false && column.field != 'notes'">
                                <label *ngIf="column.field != 'notes' && column.field !='site.code'">
                                    {{column.field | complexFieldValue: item}}
                                </label>
                                <label *ngIf="column.field =='site.code'">
                                    {{item.site?.id == SitesEnum.AllSites ? 'All Sites' : column.field | complexFieldValue: item}}
                                </label>
                            </ng-container>
                            <ng-container *ngIf="column.isCustomField == true">
                                {{item[column.field]}}
                            </ng-container>
                        </ng-template>
                    </ng-container>
                    <ng-container *ngIf="column.isTemplate">
                        <ng-template pageListColumn [field]="column.field"
                            [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                            [type]="column.type" let-item>
                            <ng-container
                                *ngIf="column.type == 'date' && column.isCustomField == false && column.field != 'notes'">
                                {{ item[column.field] | dateFormat }}
                            </ng-container>
                            <ng-container
                                *ngIf="column.type != 'date' && column.isCustomField == false && column.field != 'notes'">
                                <label *ngIf="column.field != 'notes' && column.field !='site.code'">
                                    {{column.field | complexFieldValue: item}}
                                </label>
                                <label *ngIf="column.field =='site.code'">
                                    {{item.site?.id == SitesEnum.AllSites ? 'All Sites' : column.field | complexFieldValue: item}}
                                </label>
                            </ng-container>
                            <ng-container *ngIf="column.isCustomField == true">
                                {{item[column.field]}}
                            </ng-container>
                        </ng-template>
                    </ng-container>
                </ng-container>
            </ng-container>
        </asap-grid-layout>
    </kendo-window>

    <kendo-window *ngIf="_personsListEnabled" title="" (close)="_closePersonsList()" class="addFromLibrary">
        <div class="greytabtop">
            <button kendoButton class="topRightButtonSelect" (click)="_returnSelectedPersonsHandler($event)">
                Select & Return
            </button>
        </div>
        <asap-grid-layout [selectable]="true" [singleSelect]="true" [groupingEnabled]="true" [pagingEnabled]="true"
            [headerEnable]="true" [headerTitle]="''" [entityName]="_entity" [addNewFormEnabled]="false"
            [orderEnable]="true" [sortingEnabled]="true" [page]="_personsPageName" [deletedEnabled]="false"
            [selectByField]="'id'" [selectByFieldTitle]="''" [enableSiteSelection]="false" [filteringEnable]="true"
            [HideNotesFields]="true" [resolver]="_getPersons"
            (onRowSelectionChanges)="_onPersonRowSelectionChanges($event)"
            (onRowObjectSelectionChanges)="_onPersonObjectRowSelectionChanges($event)">
            <ng-container *ngFor="let column of _personsGridFields">
                <ng-container *ngIf="column.selected">
                    <ng-container *ngIf="!column.isTemplate">
                        <ng-template pageListColumn [field]="column.field"
                            [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                            [type]="column.type" let-item>
                            <ng-container
                                *ngIf="column.type == 'date' && column.isCustomField == false && column.field != 'notes'">
                                {{ item[column.field] | dateFormat }}
                            </ng-container>
                            <ng-container
                                *ngIf="column.type != 'date' && column.isCustomField == false && column.field != 'notes'">
                                <label *ngIf="column.field != 'notes' && column.field !='site.code'">
                                    {{column.field | complexFieldValue: item}}
                                </label>
                                <label *ngIf="column.field =='site.code'">
                                    {{item.site?.id == SitesEnum.AllSites ? 'All Sites' : column.field | complexFieldValue: item}}
                                </label>
                            </ng-container>
                            <ng-container *ngIf="column.isCustomField == true">
                                {{item[column.field]}}
                            </ng-container>
                        </ng-template>
                    </ng-container>
                    <ng-container *ngIf="column.isTemplate">
                        <ng-template pageListColumn [field]="column.field"
                            [name]="column.gridFieldText ? column.gridFieldText.currentText : column.title"
                            [type]="column.type" let-item>
                            <ng-container *ngIf="column.field=='userSites.site'">
                                {{getUserSites($safeNavigationMigration(item?.user?.userSites))}}
                            </ng-container>
                            <ng-container *ngIf="column.field=='managers.manager.code'">
                                {{GetPrimaryManagerData($safeNavigationMigration(item?.managers), column.field)}}
                            </ng-container>
                            <ng-container *ngIf="column.field=='managers.manager.firstName'">
                                {{GetPrimaryManagerData($safeNavigationMigration(item?.managers), column.field)}}
                            </ng-container>
                            <ng-container *ngIf="column.field=='managers.manager.lastName'">
                                {{GetPrimaryManagerData($safeNavigationMigration(item?.managers), column.field)}}
                            </ng-container>
                            <ng-container
                                *ngIf="column.type == 'date' && column.isCustomField == false && column.field != 'notes'">
                                {{ item[column.field] | dateFormat }}
                            </ng-container>
                            <ng-container
                                *ngIf="column.type != 'date' && column.isCustomField == false && column.field != 'notes'">
                                <label *ngIf="column.field != 'notes' && column.field !='site.code'">
                                    {{column.field | complexFieldValue: item}}
                                </label>
                                <label *ngIf="column.field =='site.code'">
                                    {{item.site?.id == SitesEnum.AllSites ? 'All Sites' : column.field | complexFieldValue: item}}
                                </label>
                            </ng-container>
                            <ng-container *ngIf="column.isCustomField == true">
                                {{item[column.field]}}
                            </ng-container>
                        </ng-template>
                    </ng-container>
                </ng-container>
            </ng-container>
        </asap-grid-layout>
    </kendo-window>
    <kendo-window *ngIf="_editFormActive" [resizable]="false"
        title="{{ _isCustomfieldsFormValue ? 'Add Custom Fields' : (_isAddTabFormValue ? 'Add New Tabs' : (_isRenameFormValue ? 'Edit Record' : '')) }}"
        (close)="_closeCustomFields()" class="customFieldsWindow">
        <asap-custom-fields [accounts]="_selectedAccountIds" [labelObjectCode]="_selectedLabelObjectCode"
            [tabGroup]="_selectedTabId" [formName]="_entity" [page]="_page"
            [isCustomfieldsForm]="_isCustomfieldsFormValue" [isCustomtabsForm]="_isAddTabFormValue"
            [isRenameForm]="_isRenameFormValue" [language]="_language" [isRenameCustomForm]="_isRenameCustomFormValue"
            [isRenameLabel]="_isRenameLabel" [isMandatory]="_isMandatory" (closePopup)="ClosePopup($event)"
            [permissionScope]="_permissionScope">
        </asap-custom-fields>
    </kendo-window>

    <kendo-window *ngIf="showReports" title="Print Receipt" class="reports-window" (close)="_closePrintReceiptWindow()"
        [resizable]="false">
        <div class="row zeromarginRow p-3">
            <div class="col-12 zeroPaddingColumn">
                <div class="form-group">
                    <label class="control-label">Reservation Receipt</label>
                    <kendo-combobox #kendo_combo_Receipt_Report [data]="receiveReports" [suggest]="true"
                        class="bordered w-100" [textField]="'name'" [valueField]="'id'"
                        placeholder="Select Reservation Print Receipt">
                    </kendo-combobox>
                </div>
            </div>
            <div class="col-12 margin-top-2 zeroPaddingColumn text-end">
                <button kendoButton class="steps_buttons_class" (click)="_printReceiptReport()">
                    <img class="backimage" [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                    <span>Print</span>
                </button>
            </div>
        </div>
    </kendo-window>

    <asap-edit-forms *ngIf="_isEditForms" (close)="_onCloseEditForms($event)" (saved)="_closeCustomFields()"
        [page]="_page" [permissionScope]="_permissionScope">
    </asap-edit-forms>
    <kendo-window *ngIf="_deactivatedFieldsForm" title="Deactivated Fields" (close)="_closeInactiveFields()">
        <div class="row no_row_margin margin-top-30">
            <div class="col-12 margin-top-10">
                <kendo-grid [data]="_deactivatedFieldsGridData" [scrollable]="'none'">
                    <kendo-grid-column field="name" title="Fields Name">
                    </kendo-grid-column>
                    <kendo-grid-column field="formTab.name" title="Tab Name">
                    </kendo-grid-column>
                    <kendo-grid-column field="createdOn" title="Added Date" type="date">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{dataItem.createdOn | dateFormat}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="lastUpdatedOn" title="Deactivation Date" type="date">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            {{dataItem.lastUpdatedOn | dateFormat}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column field="Command" title="Command">
                        <ng-template kendoGridCellTemplate let-dataItem>
                            <div class="action-button action-button-deactivate" (click)="_reactivateField(dataItem)">
                                <div class="action-button-icon">
                                    <img src="/assets/menu/enterprise/deactivate-icon.svg" />
                                </div>
                                <div class="edit-icon-text">Reactivate</div>
                            </div>
                        </ng-template>
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
    </kendo-window>
